import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import GettingStarted from '@segment/templates/GettingStarted'

import LayoutBase from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import Testimonials from './components/Testimonials'
import OptimizeTheFirstTimeUserExperience from './components/OptimizeTheFirstTimeUserExperience'
import IncreaseEngagement from './components/IncreaseEngagement'

import ogImagePng from './assets/OgSegmentIndustryB2B.png'

const IndustryMarketplacesView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Data Analytics for Marketplaces | Twilio Segment"
        pageDescription="Learn why fast-growing marketplaces choose Twilio Segment"
        pageOG={ogImagePng}
      >
        <Navigation />
        <main>
          <Hero />
          <MainContent>
            <LogoCarousel />
            <IncreaseEngagement />
            <OptimizeTheFirstTimeUserExperience />
            <Testimonials />
          </MainContent>
          <GettingStarted />
        </main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

const MainContent = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default IndustryMarketplacesView
